import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import { twx } from '@ctw/shared/utils/tailwind';
import {
  faSignalBars,
  faSignalBarsFair,
  faSignalBarsGood,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ConfidenceIcon = ({ rating }: { rating: RiskGapModel['confidenceRating'] }) => {
  if (rating === 'low') {
    return (
      <FontAwesomeIcon
        icon={faSignalBarsFair}
        className="text-success-main"
        style={{ ['--fa-secondary-color' as string]: 'rgb(229, 231, 235)' }}
      />
    );
  }
  if (rating === 'medium') {
    return (
      <FontAwesomeIcon
        icon={faSignalBarsGood}
        className="text-success-main"
        style={{ ['--fa-secondary-color' as string]: 'rgb(229, 231, 235)' }}
      />
    );
  }
  if (rating === 'high') {
    return <FontAwesomeIcon icon={faSignalBars} className="text-success-main" />;
  }
  return null;
};

export const ConfidenceLabel = ({ rating }: { rating: RiskGapModel['confidenceRating'] }) => {
  return (
    <span
      className={twx('whitespace-nowrap uppercase', {
        'text-error-main': rating === 'low',
        'text-caution-main': rating === 'medium',
        'text-success-main': rating === 'high',
      })}
    >
      {rating} confidence
    </span>
  );
};
